import { render, staticRenderFns } from "./PhoneIcon.vue?vue&type=template&id=bb70f3fc&scoped=true&"
var script = {}
import style0 from "./PhoneIcon.vue?vue&type=style&index=0&id=bb70f3fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb70f3fc",
  null
  
)

export default component.exports